module.exports = [{
      plugin: require('/Users/frode/git/knowit/fag/madrid.knowit.no/node_modules/gatsby-plugin-offline/gatsby-browser'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/frode/git/knowit/fag/madrid.knowit.no/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
